<script lang="ts">
    import { applyAction } from '$app/forms';
    import { beforeNavigate } from '$app/navigation';
    import { page } from '$app/stores';
    import { isLisOnlyRoute } from '$src/lib/services/routing/lis-routes';
    import { get } from 'svelte/store';

    beforeNavigate(async ({ to, cancel }) => {
        const {
            data: { isLoggedIn, market }
        } = get(page);

        if (to && !isLoggedIn && isLisOnlyRoute(to.url.pathname, market)) {
            cancel();
            // NOTE: For now we use this workaround to throw an error from the client.
            applyAction({
                type: 'error',
                error: {
                    message: 'Unauthorized',
                    errorId: 'CLIENT_NOT_AUTHORIZED'
                }
            });
        }
    });
</script>
